import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { useSubscription } from 'context/subscriptionContext';
import { Alert, Button } from '@mui/material';
import { ROUTE_BUSINESS_COMPANY_EDIT } from 'constants/routes';
import { getLink } from 'helpers/route';

const SubscriptionAlert = (props) => {
	const { pathname } = useLocation();
	const { hasSubscription, loading } = useSubscription();

	const { currentCompany } = useSelector((state) => state.company);

	const editCompanyPath = getLink(ROUTE_BUSINESS_COMPANY_EDIT, { id: currentCompany?.id });

	if (loading) return <></>;
	if (!currentCompany) return <></>;
	if (pathname === editCompanyPath) return <></>;
	if (hasSubscription) return <></>;

	return (
		<Alert
			variant="filled"
			severity="error"
			className="subscriptionAlert"
			action={
				<Button color="inherit" size="small" variant="outlined" component={Link} to={`${editCompanyPath}#subscription`}>
					UPDATE SUBSCRIPTION
				</Button>
			}
		>
			Your subscription has expired. Please go to the subscriptions plan page and renew your payment.
		</Alert>
	);
};

export default SubscriptionAlert;
